(() => {
  const selector = 'body.template-product.ginyhome-source-port select[data-single-option-selector]';

  const enhance = (nativeSelect) => {
    if (nativeSelect.dataset.ginyhomeSelectEnhanced === 'true' || nativeSelect.type !== 'select-one') return;

    const wrapper = nativeSelect.parentElement;
    if (!wrapper) return;

    const id = `${nativeSelect.id}-menu`;
    const customSelect = document.createElement('div');
    const trigger = document.createElement('button');
    const label = document.createElement('span');
    const list = document.createElement('ul');

    customSelect.className = 'ginyhome-native-select';
    customSelect.dataset.ginyhomeNativeSelect = '';
    trigger.type = 'button';
    trigger.className = 'ginyhome-native-select__trigger';
    trigger.setAttribute('aria-controls', id);
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-haspopup', 'listbox');
    label.className = 'ginyhome-native-select__label';
    label.dataset.ginyhomeNativeSelectLabel = '';
    trigger.append(label);
    trigger.insertAdjacentHTML('beforeend', '<svg aria-hidden="true" focusable="false" viewBox="0 0 12 8"><path d="m1 1 5 5 5-5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25"></path></svg>');

    list.id = id;
    list.className = 'ginyhome-native-select__list';
    list.setAttribute('role', 'listbox');
    list.hidden = true;

    const options = [...nativeSelect.options].map((nativeOption) => {
      const item = document.createElement('li');
      const option = document.createElement('button');
      option.type = 'button';
      option.className = 'ginyhome-native-select__option';
      option.setAttribute('role', 'option');
      option.dataset.ginyhomeNativeSelectValue = nativeOption.value;
      option.textContent = nativeOption.textContent.trim();
      option.disabled = nativeOption.disabled;
      item.setAttribute('role', 'presentation');
      item.append(option);
      list.append(item);
      return option;
    });

    customSelect.append(trigger, list);
    wrapper.append(customSelect);
    nativeSelect.classList.add('ginyhome-native-select__native');
    nativeSelect.dataset.ginyhomeSelectEnhanced = 'true';
    nativeSelect.tabIndex = -1;
    nativeSelect.setAttribute('aria-hidden', 'true');

    const close = (restoreFocus = false) => {
      list.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      customSelect.classList.remove('is-open');
      if (restoreFocus) trigger.focus();
    };

    const sync = () => {
      const selectedValue = nativeSelect.value;
      const selectedOption = nativeSelect.selectedOptions[0];
      label.textContent = selectedOption ? selectedOption.textContent.trim() : '';
      options.forEach((option) => {
        const selected = option.dataset.ginyhomeNativeSelectValue === selectedValue;
        option.setAttribute('aria-selected', String(selected));
      });
    };

    const open = (focusSelected = false) => {
      list.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      customSelect.classList.add('is-open');
      if (focusSelected) {
        const selected = options.find((option) => option.getAttribute('aria-selected') === 'true' && !option.disabled);
        (selected || options.find((option) => !option.disabled))?.focus();
      }
    };

    const selectOption = (option) => {
      if (option.disabled) return;
      nativeSelect.value = option.dataset.ginyhomeNativeSelectValue;
      nativeSelect.dispatchEvent(new Event('input', { bubbles: true }));
      nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
      sync();
      close(true);
    };

    trigger.addEventListener('click', () => {
      if (list.hidden) open(true);
      else close();
    });

    trigger.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp' || event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        open(true);
      } else if (event.key === 'Escape') {
        event.preventDefault();
        close();
      }
    });

    options.forEach((option, index) => {
      option.addEventListener('click', () => selectOption(option));
      option.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          const direction = event.key === 'ArrowDown' ? 1 : -1;
          let nextIndex = index + direction;
          while (nextIndex >= 0 && nextIndex < options.length && options[nextIndex].disabled) nextIndex += direction;
          options[nextIndex]?.focus();
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          const enabled = options.filter((item) => !item.disabled);
          (event.key === 'Home' ? enabled[0] : enabled[enabled.length - 1])?.focus();
        } else if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          selectOption(option);
        } else if (event.key === 'Escape') {
          event.preventDefault();
          close(true);
        }
      });
    });

    nativeSelect.addEventListener('change', sync);
    nativeSelect.addEventListener('input', sync);
    document.addEventListener('click', (event) => {
      if (!customSelect.contains(event.target)) close();
    });
    sync();
  };

  const init = () => document.querySelectorAll(selector).forEach(enhance);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
